import { h } from "preact";
import { siteQuery, siteQueryResponse } from "../__generated__/siteQuery.graphql";
import { usePreloadedQuery } from "react-relay/hooks";
import { blogPostsPreloadedQuery, blogpostsQuery } from "../index";
import { Redirect } from "react-router-dom";

export const MusingsRedirect = () => {
    const blogCollectionData: siteQueryResponse = usePreloadedQuery<siteQuery>(blogpostsQuery, blogPostsPreloadedQuery)
    const firstEntryId = blogCollectionData.blogCollection.items[0].sys.id;
    return <Redirect to={`/musings/${firstEntryId}`} />
}